import axios from "axios";
import { authHeader, multipartHeader } from "./auth-header";

const update = (data) => {
  return axios.put(process.env.REACT_APP_API_URL + `setting/update`, data, {
    headers: multipartHeader(),
  });
};

const getAll = () => {
  return axios.get(process.env.REACT_APP_API_URL + "settings/list", {
    headers: authHeader(),
  });
};

const uploadBrandingAsset = (type, file) => {
  const formData = new FormData();
  formData.append("type", type);
  formData.append("file", file);
  return axios.post(
    process.env.REACT_APP_API_URL + "setting/branding/upload",
    formData,
    { headers: multipartHeader() }
  );
};

export default {
  update,
  getAll,
  uploadBrandingAsset,
};
